import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {CryptoService} from './crypto.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment, isODM} from '../../environments/environment';
import { of } from 'rxjs';
export const STORE_KEY_CompanionCode = 'CompanionCode';


@Injectable({
  providedIn: 'root'
})
export class CompanionService {
  companionCode: string;
  constructor(
    private http: HttpClient,
    private cryptoService: CryptoService) { }

  ReadCompanionOverView(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/companion/overview`, {otp: params});
  }

  ReadCompanionList(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/companion/list`, {otp: params});
  }

  DeleteCompanion(params): Observable <any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/companion/delete`, params);
  }

  ReadCompanionRuleList(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/companion/rule/list`, {otp: params});
  }

  UpdateCompanionRule(param): Observable <any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/companion/rule/update`, param);
  }

  SentKeyToApp(param): Observable <any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/account/mainapp/send`, param);
  }

  ReadCompanionProtectionProcessDevice(param): Observable <any> {
    // param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/companion/protection/device`, param);
  }

  ConfirmCompanionProtectionProcess(param): Observable <any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/companion/protection/confirm`, param);
  }

  SendKeyOfCompanionProtectionProcess(param): Observable <any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/companion/protection/send`, param);
  }

  ResendDataOfCompanionProtectionProcess(param): Observable <any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/companion/protection/resend`, param);
  }

  StopCompanionProtectionProcess(param): Observable <any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/companion/protection/stop`, param);
  }

  UpdateCompanionOfflineNotification(param): Observable <any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/companion/offline/notify/update`, param);
  }

  UpdateCompanionReceipt(param): Observable <any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/companion/receipt/update`, param);
  }

  set SetCompanionCode(value) {
    localStorage.setItem(STORE_KEY_CompanionCode, value);
    this.companionCode = value;
  }

  get GetCompanionCode() {
    const data = localStorage.getItem(STORE_KEY_CompanionCode);
    return data || '';
  }
}

